// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__Dhx_o","default":"Header_default__nYxFd","animation-colors":"Header_animation-colors__IhaEm"};